export const COLLECTIONS_COLORS: Record<string, { primary: string; secondary: string }> = {
    // shagreen
    jewelry: {
        primary: '#DBE8E9',
        secondary: '#CBDBDB',
    },
    // custom shades of sand
    furniture: {
        primary: '#F5EBD4',
        secondary: '#EFE2C5',
    },
    // custom color
    art: {
        primary: '#EDEDED',
        secondary: '#E7E7E7',
    },
    // custom color
    fashion: {
        primary: '#E9EFE0',
        secondary: '#E0E8D6',
    },
};
